const base = {
    imgApiUrl:process.env.VUE_APP_API_image_URL,
    baseurl:process.env.VUE_APP_API_BASE_URL
};

export default base;
